import { useMemo, useState } from 'react';
import type { PhysicianSummary } from '../lib/api';

/**
 * Temporary stand-in for login: pick yourself from the directory. Names
 * only — the directory endpoint never serves contact details.
 */
export function WhoAreYou({ physicians, onChoose }: { physicians: PhysicianSummary[]; onChoose: (abbreviation: string) => void }) {
  const [q, setQ] = useState('');
  const matches = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return physicians.filter((p) => !needle || `${p.firstName} ${p.lastName} ${p.abbreviation}`.toLowerCase().includes(needle));
  }, [physicians, q]);

  return (
    <section className="card">
      <h1>Who are you?</h1>
      <p className="muted">Temporary, until sign-in is switched on. Your choice is remembered on this device only.</p>
      <input className="search" placeholder="Type your name" value={q} onChange={(e) => setQ(e.target.value)} autoFocus aria-label="Search physicians" />
      <ul className="picklist">
        {matches.map((p) => (
          <li key={p.abbreviation}>
            <button type="button" onClick={() => onChoose(p.abbreviation)}>
              <span className="name">{p.lastName}, {p.firstName}</span>
              <span className="abbr">{p.abbreviation}</span>
            </button>
          </li>
        ))}
        {matches.length === 0 && <li className="muted">No one matches "{q}".</li>}
      </ul>
    </section>
  );
}
